/* eslint-disable max-len */
export default {
  Languages: {
    AvailableLanguages: {
      English: 'English',
      French: 'French',
      Mandarin: 'Mandarin',
      Cantonese: 'Cantonese',
      Hindustani: 'Hindustani',
      Spanish: 'Spanish',
      Punjabi: 'Punjabi',
      Arabic: 'Arabic',
      Tagalog: 'Tagalog',
      Italian: 'Italian',
      German: 'German',
      Portuguese: 'Portuguese',
      Persian: 'Persian',
      Russian: 'Russian',
      Tamil: 'Tamil',
      Vietnamese: 'Vietnamese',
      Gujarati: 'Gujarati',
      Polish: 'Polish',
      Korean: 'Korean',
      SerboCroatian: 'Serbo-Croatian',
      Greek: 'Greek',
      HaitianCreole: 'Haitian Creole',
      Ukrainian: 'Ukrainian',
      Bengali: 'Bengali',
      Romanian: 'Romanian',
      Dutch: 'Dutch',
      Cree: 'Cree',
      Japanese: 'Japanese',
      Hebrew: 'Hebrew',
      Turkish: 'Turkish',
      Malayalam: 'Malayalam',
      Hungarian: 'Hungarian',
      Ilocano: 'Ilocano',
      Somali: 'Somali',
      Swahili: 'Swahili',
      Telugu: 'Telugu',
      Other: 'Other Language',
    },
    Fluency: {
      Basic: 'Basic',
      Conversational: 'Conversational',
      Fluent: 'Fluent',
      Native: 'Native',
    },
  },

  Certificate: {
    AvailableCertifications: {
      PSW: 'Personal Support Worker (PSW)',
      DSW: 'Developmental Service Worker (DSW)',
      PAB: 'Préposé aux bénéficiaires (PAB)',
      CNA: 'Certified Nursing Assistant (CNA)',
      HCA: 'Health Care Aide (HCA)',
      RNA: 'Registered Nursing Assistant (RNA)',
      RPN: 'Registered Practical Nurse (RPN)',
      RN: 'Registered Nurse (RN)',
      CPR: 'CPR Certification',
      FIRST_AID: 'First Aid Certification',
      PSW_STUDENT: 'PSW Student',
      NURSING_STUDENT: 'Nursing Student',
    },
  },
};
